import { useIdFilter } from "shared-ts/hooks/useFilter"
import { stringComparator } from "shared-ts/utils/sorting/comparators"

import { useListProductCategoriesForCompanyV2Query } from "features/api/company"
import { departmentFilterKey } from "hooks/filters/filterKeys"
import { useWebFilter, UseWebFilterProps } from "hooks/filters/useWebFilter"

export { departmentFilterKey }

export function useDepartmentFilter({
  persistInUrl = true,
}: Partial<Pick<UseWebFilterProps<unknown>, "persistInUrl">> = {}) {
  const { data } = useListProductCategoriesForCompanyV2Query({})

  const { filter, selected: selectedDepartmentIds } = useIdFilter({
    key: departmentFilterKey,
    label: "Department",
    values: data?.departments ?? [],
    sort: stringComparator((category) => category.name),
    labelExtractor: (department) => department.name,
    useFilter: (props) => useWebFilter({ ...props, persistInUrl }),
  })

  return { filter, selectedDepartmentIds }
}
